/** Federated gateway GraphQL endpoints (experience hockey lives here). */
export const GRAPHQL_GATEWAY_URL = {
  dev: 'https://use1-dev-th-gateway.rbictg.com/graphql',
  staging: 'https://use1-staging-th-gateway.rbictg.com/graphql',
  prod: 'https://use1-prod-th-gateway.rbictg.com/graphql',
  qa: 'https://use1-prod-th-gateway.rbictg.com/graphql',
};

/**
 * Resolve transport for the iframe `env` query param.
 * Every hosted env uses the federated gateway. `qa` and unknown values share
 * production because th-app loads hockey.prod.loyalty with `env=qa`.
 */
export function resolveApiEndpoints(env) {
  const graphqlUrl = GRAPHQL_GATEWAY_URL[env] || GRAPHQL_GATEWAY_URL.prod;
  return {
    useGraphql: true,
    graphqlUrl,
    apiUrl: null,
  };
}

const createRoute = (baseUrl) => (proxy, route) => `${baseUrl}/${proxy}/${route}`;

export const getEndpoint = (baseUrl) => {
  const setEndpoint = createRoute(baseUrl);

  return {
    quiz: setEndpoint('user', 'stq'),
    notification: setEndpoint('user', 'preferences'),
    pickHistory: setEndpoint('hockey', 'picks/history'),
    players: setEndpoint('hockey', 'picks'),
    playerPicks: setEndpoint('hockey', 'picks'),
    user: setEndpoint('hockey', 'user'),
    userStats: setEndpoint('hockey', 'user/stats'),
    leaderboard: setEndpoint('hockey', 'contest/challenge/leaderboard'),
    postSeasonLeaderboard: setEndpoint('hockey', 'contest/postseason/leaderboard'),
    seasonLeaderboard: setEndpoint('hockey', 'contest/season/leaderboard'),
    leaderboardLocal: setEndpoint('hockey', 'contest/challenge/leaderboard/local'),
    postSeasonLeaderboardLocal: setEndpoint('hockey', 'contest/postseason/leaderboard/local'),
    seasonLeaderboardLocal: setEndpoint('hockey', 'contest/season/leaderboard/local'),
  };
};
